export const DEFAULT_CONSENT_MESSAGE =
  'I agree to use electronic records and electronic signatures and understand that my electronic signature is legally binding.';

export function resolveConsentMessage(tokenOptions = {}) {
  if (tokenOptions?.requireConsentAgreement && tokenOptions?.overrideConsentMessage) {
    const custom = (tokenOptions.consentMessage || '').trim();
    if (custom) return custom;
  }
  return DEFAULT_CONSENT_MESSAGE;
}

export function resolveConsentImageText(tokenOptions = {}) {
  return `\u2611 ${resolveConsentMessage(tokenOptions)}`;
}
